import { Injectable } from '@angular/core';
import { InventoryAttribute, InventoryItem } from 'src/app/core/models/inventory.model';
import { LocalStorageService } from 'src/app/core/storage/local-storage/local-storage.service';
import { InventoryService } from './inventory.service';

@Injectable({
	providedIn: 'root'
})
export class TruckInventoryService {

	constructor(
		private storage: LocalStorageService,
		private inventoryService: InventoryService
	) { }

	async getTruckInventory(categoryId: number, equipmentId: number): Promise<InventoryItem> {
		const items = await this.storage.truckInventory.getAll() as InventoryItem[];
		return items.find(i => i.categoryId === categoryId && i.equipId === equipmentId);
	}

	async getAllTruckInventory(): Promise<InventoryItem[]> {
		return await this.storage.truckInventory.getAll() as InventoryItem[];
	}

	async addTruckInventory(apptId: number, truckInventory: InventoryItem, updatedAttributes: InventoryAttribute[]) {
		this.inventoryService.addInventoryToAppointmentHttp(apptId, truckInventory, updatedAttributes);
		await this.addTruckInventoryLocal(apptId, truckInventory);
	}

	async addTruckInventoryLocal(apptId: number, truckInventory: InventoryItem) {
		await this.inventoryService.addInventoryToAppointmentLocal(apptId, truckInventory);
		await this.storage.truckInventory.removeItem(`${truckInventory.id}`);
	}
}
